module.exports = __webpack_public_path__ + "img/pic20.26db85a6.png";